import React, { useState } from 'react';
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';
import { APP_SETTINGS_PRIMARY_COLOR } from '../../../../../constants';
import { styles } from './style';

import StripeInput from '../StripeInput';

function ElementWrapper({ component, label, font, id, setCompleted }) {
  const [focused, setFocused] = useState(false);
  const [error, setError] = useState(false);
  const [empty, setEmpty] = useState(true);
  const [inputNode, setInputNode] = useState(null);

  const handleFocus = () => setFocused(true);
  const handleBlur = () => setFocused(false);

  const handleChange = ({ error, empty, complete }) => {
    setCompleted(complete);
    setError(error);
    setEmpty(empty);
  };

  const handleLabelClick = () => {
    if (inputNode) {
      inputNode.focus();
    }
  };

  return (
    <TextField
      id={id}
      sx={styles.textField}
      label={label}
      error={!!error}
      helperText={error && error.message}
      data-css-selector="payment field"
      InputLabelProps={{
        sx: {
          fontFamily: font || 'system-ui',
          ...styles.inputLabel,
        },
        onClick: handleLabelClick,
        shrink: focused || !empty,
        error: !!error,
        focused,
      }}
      InputProps={{
        sx: {
          '& .MuiInputBase-input': {
            ...styles.input,
            borderColor: focused ? APP_SETTINGS_PRIMARY_COLOR : '#f2f2f2',
          },
        },
        fullWidth: true,
        onFocus: handleFocus,
        onBlur: handleBlur,
        onChange: handleChange,
        inputComponent: StripeInput,
        inputProps: {
          component,
          setInputNode,
          inputNode,
          font,
        },
      }}
      FormHelperTextProps={{
        sx: {
          display: error ? 'block' : 'none',
          fontFamily: font || 'system-ui',
          ...styles.formHelperText,
        },
      }}
    />
  );
}

ElementWrapper.propTypes = {
  component: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  font: PropTypes.string,
};

export default ElementWrapper;
